"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillAdSetToJSON = exports.BillAdSetFromJSONTyped = exports.BillAdSetFromJSON = exports.instanceOfBillAdSet = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the BillAdSet interface.
 */
function instanceOfBillAdSet(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBillAdSet = instanceOfBillAdSet;
function BillAdSetFromJSON(json) {
    return BillAdSetFromJSONTyped(json, false);
}
exports.BillAdSetFromJSON = BillAdSetFromJSON;
function BillAdSetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'amountInMicros': !(0, runtime_1.exists)(json, 'amount_in_micros') ? undefined : json['amount_in_micros'],
        'startDate': !(0, runtime_1.exists)(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
    };
}
exports.BillAdSetFromJSONTyped = BillAdSetFromJSONTyped;
function BillAdSetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'amount_in_micros': value.amountInMicros,
        'start_date': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
    };
}
exports.BillAdSetToJSON = BillAdSetToJSON;
